<!--
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-01-15 14:04:15
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-07-23 18:49:37
 * @FilePath: \crm-product\found\views\sfa\views\attendance_manage\customer_change\form.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script>
import Form, { formCreate } from '@/found/components/form';
import request from '@/found/utils/request';
import seriesVos from './table.vue';

formCreate.component('seriesVos', seriesVos);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formFunctionCode: 'customer_contact_person',
      formParentCode: 'CRM20211218000000002',
    };
  },

  methods: {
    formComplete() {
      console.log('3333', this.formConfig, this.formConfig.row);
      if (this.formConfig.row && this.formConfig.row.id) {
        request.get('/mdm/customerMatchmakerController/queryDetail', {
          id: this.formConfig.row.id,
        }).then((res) => {
          if (res.success) {
            const { result } = res;
            this.setValue(result);
          }
        });
      }
    },
  },
};
</script>
